import { useEffect, useState } from "react";
import { Note } from "../../components/Note";
import { API } from "../../core/api";

const stockTypes = [
  ["warehouse", "موجود در انبار"],
  ["supply", "تامین شده"],
  ["admin", "دستی"],
];

const useProductCityStock = () => {
  const [productCityStocks, setProductCityStocks] = useState([]);
  const [cities, setCities] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [file, setFile] = useState(null);
  const [fileList, setFileList] = useState([]);

  const [loading, setLoading] = useState(false);
  const [isUpLoading, setIsUpLoading] = useState(false);

  const getCities = () => {
    API.get
      .cities()
      .then((response) => {
        if (response.success) {
          setCities(response.data);
        } else {
          Note.error(response.message);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const getProductCityStocks = (data) => {
    setLoading(true);
    API.get.product_city_stocks(data).then((response) => {
      setLoading(false);
      if (response.success) {
        setProductCityStocks(response.data);
      } else {
        Note.error(response.message);
      }
    });
  };

  useEffect(() => {
    getCities();
  }, []);

  const onSubmit = (data) => {
    const newData = {
      product_id: data.product_id ? Number(data.product_id) : null,
      city_id: data.city_id ? Number(data.city_id) : null,
      ...data,
    };
    newData.start_date = data.start_date
      ? `${data.start_date.$jy}-${data.start_date.$jM + 1}-${
          data.start_date.$jD
        }`
      : null;
    newData.end_date = data.end_date
      ? `${data.end_date.$jy}-${data.end_date.$jM + 1}-${data.end_date.$jD}`
      : null;

    getProductCityStocks(newData);
  };

  const beforeUpload = (file) => {
    setFile(file);
    setFileList([file]);
    setShowConfirmModal(true);
    return false;
  };

  const onRemove = (file) => {
    setFile(null);
    setFileList([]);
    setIsUpLoading(false);
    setShowConfirmModal(false);
  };

  const uploadExcelProducts = () => {
    setIsUpLoading(true);
    const formData = new FormData();
    formData.append("excel_file", file);
    API.post.upload_product_city_stocks(formData).then((response) => {
      if (response.success && response.code !== 404) {
        onRemove();
        Note.success("فایل مورد نظر با موفقیت آپلود شد");
      } else {
        onRemove();
        Note.error(response.message);
      }
    });
  };

  return [
    cities,
    loading,
    productCityStocks,
    stockTypes,
    onSubmit,
    showConfirmModal,
    file,
    fileList,
    onRemove,
    beforeUpload,
    uploadExcelProducts,
    isUpLoading,
  ];
};

export default useProductCityStock;
